import styled from 'styled-components';

// Dashboard
export const Dashboard = styled.div`
  height: 100vh;
  width: calc(100vw - 5%);
  margin-left: 5%;
  background-color: #fbf7f4;
  display: flex;
  font-family: 'Open Sans', sans-serif;
  position: relative;

  .linkBtn {
    background-color: transparent;
    border: 0;
    padding: 0;
    font-size: 0.7rem;
    cursor: pointer;
    font-family: 'Open Sans', sans-serif;
    text-decoration: underline;
    text-underline-position: under;

    :hover {
      text-decoration: none;
    }
  }
`;

export const Sidebar = styled.div`
  position: relative;
  width: ${props => props.width};
  padding: 0 2rem;
  background-color: #fff;
  border-radius: 0 2rem 2rem 0;
  box-shadow: rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
  z-index: 1;
  overflow: hidden;
  animation: slideIn 400ms ease;
  @keyframes slideIn {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0%);
    }
  }
`;

export const Loader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  background: rgba(255, 255, 255, 0);
  backdrop-filter: blur(5px);
  .ant-spin-dot-item {
    background-color: #f9dc06;
  }
`;

export const Title = styled.h1`
  font-size: 1.2rem;
  text-transform: uppercase;
  height: ${props => props.height};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: 'Oswald', sans-serif;
  @media only screen and (min-width: 1640px) {
    font-size: 1.6rem;
  }
`;

export const Filters = styled.div`
  height: ${props => props.height};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  .label{
    font-weight: bold;
    font-size: 14px;
  }
  .ant-select {
    font-size: 0.7rem;
    margin-left: 12px;
    @media only screen and (min-width: 1640px) {
      font-size: 0.9rem;
    }
  }
  .ant-select-selection--single {
    border-radius: 30px;
    background: #f1f0f6;
    @media only screen and (min-width: 1640px) {
      height: 36px;
      padding: 2px 0;
    }
  }
  .ant-input {
    cursor: pointer;
    border-radius: ${props => props.statusMonitoring ?'none': '30px' };
    background-color: ${props => props.statusMonitoring ?'none': '#f1f0f6' };
    @media only screen and (min-width: 1640px) {
      height: 36px;
    }
  }
  .anticon svg {
    color: #000;
  }
  .ant-calendar-range-picker-input:placeholder-shown {
    font-size: 0.7rem;
    @media only screen and (min-width: 1640px) {
      font-size: 0.9rem;
    }
  }
  .ant-select-selection--single .ant-select-selection__rendered {
    color: #000;
  }
  .ant-calendar-range-picker-input {
    cursor: pointer;
    color: #000;
    font-size: 0.7rem;
    @media only screen and (min-width: 1640px) {
      font-size: 0.9rem;
    }
  }
  ${props => props.statusMonitoring && `
    gap: 24px;
    justify-content: flex-start;
    .ant-calendar-range-picker-input:placeholder-shown {
      font-family: 'Lato', sans-serif;
      font-size: 14px;
    }
    .ant-select-selection--single .ant-select-selection__rendered {
      font-family: 'Lato', sans-serif;
    }
    .ant-select {
      font-size: 14px;
      margin-left: 0;
    }
    .ant-select-selection--single {
      border-radius: 4px;
      background: #fff;
    }
  `}
`;

export const CardsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  height: ${props => props.height};
  padding: 18px 0;
  column-gap: 12px;
  row-gap: 12px;
  @media only screen and (min-width: 1640px) {
    column-gap: 24px;
    row-gap: 24px;
  }
`;

export const Cards = styled.div`
  height: ${props => props.height};
  width: ${props => props.width};
  display: flex;
  align-items: center;
  justify-content: ${props => (props.templatesCount ? 'space-evenly' : 'space-between')};
  flex-direction: ${props => !props.templatesCount && 'column'};
  position: ${props => !props.templatesCount && 'relative'};
  background: ${props => props.bgColor};
  border-radius: ${props => (props.templatesCount ? '12px' : '16px')};
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
  animation-name: ${props => props.animation};
  animation-duration: ${props => (props.templatesCount ? '600ms' : '1s')};
  animation-timing-function: ease;
  animation-delay: ${props => props.animationDelay};
  animation-fill-mode: both;
  padding: ${props => !props.templatesCount && '8px'};
  text-align: ${props => !props.templatesCount && 'center'};
  padding-left: ${props => props.id === 5 && '5px'};
  @keyframes popUp {
    from {
      opacity: 0;
      transform: scale(0%);
    }
    to {
      opacity: 1;
      transform: scale(100%);
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(30%);
    }
    100% {
      opacity: 1;
      transform: translateY(0%);
    }
  }
  @media only screen and (min-width: 1640px) {
    height: ${props =>
      props.id === 1
        ? '30%'
        : props.id === 4
        ? '26%'
        : props.id === 5
        ? '42%'
        : !props.templatesCount
        ? '138px'
        : '34%'};
    width: ${props => !props.templatesCount && '126px'};
  }
  .count {
    position: relative;
    color: ${props => props.textColor};
    font-weight: 600;
    font-size: ${props => props.countFontSize};
    font-family: 'Oswald', sans-serif;
    padding-left: ${props => props.id === 3 && '10px'};
    @media only screen and (min-width: 1640px) {
      font-size: ${props => (props.id === 1 ? '1.8rem' : '1.6rem')};
      padding-left: ${props => props.id === 3 && '18px'};
    }
  }
  a {
    display: block;
    font-size: 0.7rem;
    color: #fff;
    text-underline-position: under;
    font-family: 'Open Sans', sans-serif;
    @media only screen and (min-width: 1640px) {
      font-size: 0.8rem;
    }
  }
  .title {
    position: absolute;
    top: ${props => (props.id === 5 ? '-10%' : '-14%')};
    left: ${props => props.id === 5 && '2%'};
    background: black;
    color: white;
    width: ${props => (props.id === 5 ? '40%' : '80%')};
    text-align: center;
    border-radius: 30px;
    padding: 4px 0;
    font-size: 0.7rem;
    @media only screen and (min-width: 1640px) {
      top: ${props => (props.id === 5 ? '-8%' : '-10%')};
      font-size: 0.9rem;
    }
  }
  .shortMessageStats {
    position: relative;
    font-weight: 700;
    text-align: center;
    h4 {
      font-size: 0.7rem;
      text-transform: uppercase;
      @media only screen and (min-width: 1640px) {
        font-size: 0.9rem;
      }
    }
    h3 {
      font-size: 1rem;
      @media only screen and (min-width: 1640px) {
        font-size: 1.2rem;
      }
    }
    a {
      color: blue;
    }
  }
  .subText {
    position: absolute;
    bottom: 10%;
    color: #000;
    font-weight: 700;
    font-size: 0.8rem;
  }
  .icon {
    position: absolute;
    top: -12%;
    height: 28px;
    width: 28px;
    background-color: #060036;
    border-radius: 50%;
    padding: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      background-size: 28px 28px;
    }
    @media only screen and (min-width: 1640px) {
      width: 34px;
      height: 34px;
    }
  }
  .text {
    font-size: 0.7rem;
    font-weight: 700;
    margin-top: 20px;
    text-transform: uppercase;
    @media only screen and (min-width: 1640px) {
      font-size: 0.8rem;
    }
  }
  .percentage {
    font-size: 1.1rem;
    font-weight: 800;
    margin-bottom: 6px;
    @media only screen and (min-width: 1640px) {
      font-size: 1.4rem;
    }
  }
`;

export const Subtitle = styled.div`
  font-weight: 600;
  font-size: 1.1rem;
  text-transform: uppercase;
  height: ${props => props.height};
  color: #000;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  text-align: center;
  font-family: 'Oswald', sans-serif;
  @media only screen and (min-width: 1640px) {
    padding-top: 35px;
    font-size: 1.4rem;
  }
`;

export const FailureReasons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${props => props.height};
  width: ${props => props.width};
  column-gap: 12px;
`;

export const LinkText = styled.div`
  height: ${props => props.height};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.7rem;
  @media only screen and (min-width: 1640px) {
    font-size: 1rem;
  }
`;

export const TemplatesList = styled.div`
  position: absolute;
  height: 100vh;
  width: ${props => props.screenWidth};
  right: 0;
  top: 0;
  padding: 24px;
  text-align: right;
  background: #f2f2f2;
  transform: ${props => (props.templatesView ? 'translateX(0%)' : 'translateX(-200%)')};
  transition: transform 600ms ease;
  border-radius: 0 30px 30px 0;
  box-shadow: rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  justify-content: center;
  align-items: center;
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 8px;
    font-size: 0.8rem;
    font-family: 'Open Sans', sans-serif;
    @media only screen and (min-width: 1640px) {
      font-size: 1rem;
    }
  }
  .failed-templates-table {
    width: 100%;
    .ant-table {
      height: 60vh;
      overflow-x: scroll;
      ::-webkit-scrollbar {
        display: none;
      }
    }
    ::-webkit-scrollbar {
      display: none;
    }
  }

  .top10-templates-table {
    .ant-table {
      width: 100%;
      height: 60vh;
      overflow: auto;
    }
  }
`;

export const CloseIcon = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  font-size: 1.2rem;
  padding: 18px;
  line-height: 1;
  cursor: pointer;
`;

export const ChartsSection = styled.div`
  position: relative;
  padding: 2%;
  width: ${props => props.width};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6rem;
  flex-wrap: wrap;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`;

// Email Dashboard
export const StyledFunnelChart = styled.div`
  height: ${props => props.height};
  display: flex;
  flex-direction: column;
  justify-content: center;
  .chartTitle {
    text-align: left;
    font-size: 1.1rem;
    padding: 12px 0;
    font-weight: 700;
    @media only screen and (min-width: 1640px) {
      font-size: 1.4rem;
    }
  }
  .chartContainer {
    display: flex;
    align-items: flex-start;
  }
  hr {
    height: 1px;
    background: blue;
  }
  .chartData {
      z-index: 1;
  }
  .chartData,
  .funnel {
    width: 50%;
  }
  .dataRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;
    @media only screen and (min-width: 1640px) {
      height: 52px;
    }
    p {
      font-size: 0.8rem;
      white-space: no-wrap;
      span {
        color: green;
        font-weight: 700;
      }
      @media only screen and (min-width: 1640px) {
        font-size: 1.1rem;
      }
    }
    ${props => props.clickable && `
      :not(:last-child):hover {
        background: #deecff;
        padding-inline: 8px;
        cursor: pointer;
        transition: all 0.2s linear;
    }`};
  }
  .selected {
    background: #deecff;
    padding-inline: 8px;
    margin-block: 1px;
  }
  .rowTitle {
    display: flex;
    align-items: center;
  }
  .identifier {
    height: 10px;
    width: 10px;
    margin-right: 8px;
    border-radius: 50%;
  }
  .funnel {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 0;
  }
  .barsContainer {
    width: 60%;
    row-gap: 20px;
  }
  .bars {
    height: 30px;
    width: 100%;
    ${props => props.clickable && `
      :hover {
        cursor: pointer;
        filter: brightness(0.5);
        transition: all 0.3s linear;
    }`};
    @media only screen and (min-width: 1640px) {
      height: 52px;
    }
  }
  .selected-bar {
    filter: brightness(0.5);
  }
  .skewLeft,
  .skewRight {
    position: absolute;
    top: 0;
    width: 25%;
    height: 100%;
    background: ${props => props.maskColor};
    @media only screen and (min-width: 1640px) {
      width: 22%;
    }
  }
  .skewLeft {
    left: 10%;
    transform: skewX(20deg);
    box-shadow: -2px 0px 0px 10px ${props => props.maskColor};
    @media only screen and (min-width: 1640px) {
      left: 8%;
      transform: skewX(18deg);
    }
  }
  .skewRight {
    right: 10%;
    transform: skewX(-20deg);
    box-shadow: 0px -2px 0px 10px ${props => props.maskColor};
    @media only screen and (min-width: 1640px) {
      right: 8%;
      transform: skewX(-18deg);
    }
  }
`;

export const FailureStatsSection = styled.div`
  display: flex;
  height: ${props => props.height};
  align-items: center;
  column-gap: 24px;
`;

export const Stats = styled.div`
  width: 65%;
  height: 100%;
`;

export const TemplateLink = styled.button`
  background: none!important;
  border: none;
  padding: 0!important;
  color: #069;
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
`

export const ModalData = styled.p`
  padding: 1rem;
  border: 1px solid rgba(0, 0, 0, .3);
  border-radius: 5px;
  background-color: rgba(0, 0, 0, .05);
  max-height: 15rem;
  overflow: auto;
`

export const ModalHeading = styled.h3`
  font-size: 18px;
  text-transform: uppercase;
  text-align: center;
  margin: 30px 0;
`